import axiosInstance from '../axiosInstance';
import { ICreateProfilePayload, IProfileResponse } from '../../types/Profile';

export const createNewProfile = async (payload: ICreateProfilePayload) => {
  const response = await axiosInstance.post<IProfileResponse>('/profiles', {
    first_name: payload.firstName,
    last_name: payload.lastName,
    middle_name: payload.middleName,
    born_at: payload.bornAt,
    birth_location: payload.location,
  });
  return {
    firstName: response.data.first_name,
    lastName: response.data.last_name,
    middleName: response.data.middle_name,
    bornAt: response.data.born_at,
    location: response.data.location,
    token: response.data.token,
    isDefault: response.data.is_default,
    createdAt: response.data.created_at,
    updatedAt: response.data.updated_at,
  };
};

export const getUserProfiles = async () => {
  const response = await axiosInstance.get<IProfileResponse[]>('/profiles');
  return response.data.map(profile => {
    return {
      firstName: profile.first_name,
      lastName: profile.last_name,
      middleName: profile.middle_name,
      bornAt: profile.born_at,
      location: profile.location,
      token: profile.token,
      isDefault: profile.is_default,
      createdAt: profile.created_at,
      updatedAt: profile.updated_at,
    };
  });
};

export const getCurrentProfile = async () => {
  const response = await axiosInstance.get<IProfileResponse>('/profiles/current');
  return {
    firstName: response.data.first_name,
    lastName: response.data.last_name,
    middleName: response.data.middle_name,
    bornAt: response.data.born_at,
    location: response.data.location,
    token: response.data.token,
    isDefault: response.data.is_default,
    createdAt: response.data.created_at,
    updatedAt: response.data.updated_at,
  };
};

export const setDefaultProfile = async (profileToken: string) => {
  if (!profileToken) {
    throw new Error('Profile token is required');
  }
  return await axiosInstance.post(
    '/profiles/current/set-as-default',
    {},
    {
      headers: {
        Authorization: `Bearer ${profileToken}`,
      },
    },
  );
};

export const deleteCurrentProfile = async (profileToken: string) => {
  if (!profileToken) {
    throw new Error('Profile token is required');
  }

  return await axiosInstance.delete('/profiles/current', {
    headers: {
      Authorization: `Bearer ${profileToken}`,
    },
  });
};
